/* eslint-disable max-lines-per-function */
import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import FundoAmarelo from '../../../assets/fundo_amarelo.png';

import { DataTable } from 'primereact/datatable';
import { CadastrarTV } from './atom/CadastrarTV.jsx';
import { ExcluirRegistro } from './atom/ExcluirRegistro.jsx';
import { Column } from 'primereact/column';
import 'primeicons/primeicons.css';
import { EditarTvs } from './atom/EditarTvs.jsx';
import { VincularGrupo } from './atom/VincularGrupo.jsx';
import DialogCrud from '../shared/DialogCrud.jsx';
import TvService from '../../../services/tvs/TvService.js';

import grupoTvService from '../../../services/tvs/grupoTvService';

import './style.css';

export function CadastrarTvs() {
    const [dadosParametros, setDadosParametros] = useState([]);
    const [modalAberto, setModalAberto] = useState(false);
    const [modalEdicaoAberto, setModalEdicaoAberto] = useState(false);
    const [modalVincularTVAberto, setModalVincularTVAberto] = useState(false);
    const [recarregarDataTable, setRecarregarDataTable] = useState(true);
    const [rowSelecionada, setRowSelecionada] = useState([]);
    const [openModalCadastro,setOpenModalCadastro] = useState(false);
    const [dadosGrupo,setDadosGrupo] = useState([]);

    const abrirModal = () => setModalAberto(true);
    const abrirModalEdicao = () => setModalEdicaoAberto(true);
    const abrirModalVincularTV = () => setModalVincularTVAberto(true);
    const zero = 0;

    const Grupo = rowData => {
        const no = dadosGrupo.filter(e => e.id === rowData.idGrupo);

        return (

            <p>{!rowData.idGrupo ? 'Aparelho não vinculado': no[zero]?.nome}</p>

        );};

    const VincularGrupoB = rowData => (

        <i className="pi pi-link"
            onClick={() => {
                abrirModalVincularTV();
                setRowSelecionada(rowData);
            }} style={{ 'fontSize': '2em',
                color: '#03258C' }}></i>

    );

    const bodyAcoes = rowData => (
        <div className="acoes" style={{ display: 'flex',
            gap: '8px',
            justifyItems: 'center',
            justifyContent: 'space-evenly',
            color: '#03258C'  }}>

            <i className="pi pi-trash"  onClick={() => {
                abrirModal();
                setRowSelecionada(rowData);
            }} style={{ 'fontSize': '2em' }}></i>
            <i className="pi pi-pencil"
                onClick={() => {
                    abrirModalEdicao();
                    setRowSelecionada(rowData);
                }} style={{ 'fontSize': '2em' }}></i>
        </div>
    ); //

    const header = <img src={FundoAmarelo} />;

    useEffect(() => {
        (async () => {
            try {
                const { data } = await TvService.buscarTodaTVs();
                const dataGrupo = await grupoTvService.getGrupo();

                setDadosGrupo(dataGrupo.data);

                setDadosParametros(data);
                setRecarregarDataTable(false);
            } catch {
                setRecarregarDataTable(false);
                throw new Error();
            }
        })();
    }, [recarregarDataTable]);

    return (
        <Card className='tratar-scroll-card' header={header} title="Aparelhos televisores">
            <div className="p-col">
                <div className="p-grid p-fluid">
                    <div className="p-col size-spinner">
                        <Card style={{ fontSize: '11px' }}>
                            <Button style={{ width: '95px' }} label={'Cadastrar'} onClick={setOpenModalCadastro.bind(this,true)}/>
                            <DialogCrud title={'Cadastrar aparelhos televisores'} openModal={openModalCadastro} setOpenModal={setOpenModalCadastro}>
                                <CadastrarTV setOpenModalCadastro={setOpenModalCadastro} setRecarregarDataTable={setRecarregarDataTable} />
                            </DialogCrud>
                        </Card>
                        <DataTable
                            paginator
                            responsive
                            rows={5}
                            style={{ textAlign: 'center',
                                overflow: 'hidden' }}
                            value={dadosParametros.filter(s => s.status != zero)}
                            scrollable={false}
                            sortField="dataUpdated"
                            sortOrder={-1}
                            loading={recarregarDataTable}
                            loadingIcon="pi pi-spin pi-spinner"
                            emptyMessage="Sem grupos cadastrados"
                        >
                            <Column
                                field="nome"
                                header="Nome do aparelho"
                                style={{ width: '14rem',
                                    height: '4rem' }}
                                filter
                                filterPlaceholder="Filtrar por nome"
                            />
                            <Column
                                field="Grupo"
                                header="Grupo"
                                body={Grupo}
                                style={{
                                    overflow: 'hidden',
                                    width: '14rem',
                                    height: '4rem'
                                }}
                            />
                            <Column
                                header="Vincular grupo(Grade de programação)"
                                body={VincularGrupoB}
                                style={{ width: '14rem',
                                    height: '4rem' }}
                            />

                            <Column
                                header="Ações"
                                body={bodyAcoes}
                                style={{ width: '14rem',
                                    height: '4rem' }}
                            />
                        </DataTable>
                        <EditarTvs
                            rowSelecionada={rowSelecionada}
                            modalEdicaoAberto={modalEdicaoAberto}
                            setModalEdicaoAberto={setModalEdicaoAberto}
                            setRecarregarDataTable={setRecarregarDataTable}
                        />
                    </div>

                    <ExcluirRegistro
                        rowSelecionada={rowSelecionada}
                        modalAberto={modalAberto}
                        setModalAberto={setModalAberto}
                        setRecarregarDataTable={setRecarregarDataTable}
                    />

                    <VincularGrupo
                        dadosGrupo={dadosGrupo}
                        rowSelecionada={rowSelecionada}
                        modalVincularTVAberto={modalVincularTVAberto}
                        setModalVincularTVAberto={setModalVincularTVAberto}
                        setRecarregarDataTable={setRecarregarDataTable}
                    />
                </div>
            </div>
        </Card>
    );
}
